/**
 * Created by user on 21/11/16.
 */

export class VehiclesModel {
  public vehicleid: number;
  public companyid: number;
  public vehicletypeid: number;
  public calltypeid: number;
  public year: number;
  public make: string;
  public model: string;
  public doors: number;
  public ambulatorycapacity: number;
  public wheelchaircapacity: number;
  public vin: string;
  public tag: string;
  public registrationexpdate: string;
  public registrationexpdateformatted: string;
  public registrationphoto: string;
  public isactive: boolean;
  public insurancename: string;
  public insurancepolicy: string;
  public policyexpirydate: string;
  public policyexpirydateformatted: string;
  public insurancephoto: string;
  public vehiclestatusid: number;
  public code: string;
  public colorid: number;
  public driverid: number;
  public isapproved: boolean;
  public prescheduled: boolean;
  public vehiclecycleid: number;
  public referencecode: string;
  public stretchercapacity: number;
  public depotid: number;
  public vehiclephotos: any[];
  public sunpass: string;
  public vehiclenote?: string;

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/pages/vehicles/vehicles.model.ts